import RelatedOrders from './RelatedOrders';
import RelatedOrder from '../../../Models/Content/RelatedOrdersBlockData'

import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';


export default class RedirectToUrl extends EpiComponent<RelatedOrder>
{
    constructor(props) {
        super(props);  
    }

    public render() : ReactNode | ReactNodeArray | null
    {
        return (
            <RelatedOrders context={this.getContext()} iContent={this.props.data} />    
        );
    }
}